import { Component } from '@angular/core';
import { ContratoArrendamento } from '../../../models/arrendamento/contrato-arrendamento.model';
import { FiltroArrendamento } from './../../../models/arrendamento/filtro-arrendamento.model';
import { ContratoArrendamentoService } from './../../../services/contrato-arrendamento.service';
import { ModalService } from '../../../services/modal.service';

@Component({
    selector: 'historico-contrato-arrendamento',
    templateUrl: 'historico-contrato-arrendamento.component.html',
    styleUrls: [ 'historico-contrato-arrendamento.component.scss']
})

export class HistoricoContratoArrendamentoComponent{
    contratos: ContratoArrendamento[] = []; 

    constructor(private contratoArrendamentoService: ContratoArrendamentoService, private modalService: ModalService) {}

    onFilterChangeEmitterHandler(filtro: FiltroArrendamento) {
        this.contratoArrendamentoService.listarContratos(filtro).subscribe(
            resp => {
                this.contratos = resp.data;

                if (!this.contratos || !this.contratos.length) {
                    this.modalService.important("Nenhum contrato encontrado para pequisa informada !");
                }

                console.log('this.contratos', this.contratos);
            },
            error => {
                this.modalService.error(error.error.message);
            }   
        );
    }
}
